import { GamesGridDefaultBox } from './games-grid.default.box';
import { GamesGridCasino777Box } from './games-grid.casino777.box';
import { styledByTheme } from '../../../../themes/architecture/styled-by-theme';
import { GamesGridSICisBox } from './games-grid.siCis.box';

export const GamesGridBox = styledByTheme(GamesGridDefaultBox)
    .forCasino777(GamesGridCasino777Box)
    .forSICis(GamesGridSICisBox)
    .apply();